import React from 'react';
import { segmentChips } from '../fixtures/segments';
import { attributeById as defaultAttributeById } from '../fixtures/attributes';

// Entry criteria for a journey, shown as chips. No edit affordance of its own:
// segment ↔ journey is 1:1, so the journey header's pencil edits the segment too.
export default function SegmentBar({ segment, attributeById = defaultAttributeById, maxChips = 3 }) {
  const chips = segmentChips(segment, attributeById);
  const shown = chips.slice(0, maxChips);
  const extra = chips.length - shown.length;
  return (
    <div className="tl-segbar">
      <div className="tl-segbar-lbl">TRIGGERS WHEN</div>
      <div className="tl-chips">
        {shown.map((c, i) => <span key={i} className="tl-chip">{c}</span>)}
        {extra > 0 && <span className="tl-chip tl-chip-more">+{extra} more</span>}
      </div>
    </div>
  );
}
